import axios from "axios";
import NProgress from "nprogress";
import "./css/nprogress.css";

// Create an Axios instance
const axiosInstance = axios.create();

// Configure NProgress to show spinner
NProgress.configure({ showSpinner: true });

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    NProgress.start();
    return config;
  },
  (error) => {
    NProgress.done();
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    NProgress.done();
    return response;
  },
  (error) => {
    NProgress.done();
    return Promise.reject(error);
  }
);

export default axiosInstance;
